import { styled, Box } from '@mui/material'
import { isNilOrEmpty } from 'packages/core'
import { useHistory } from 'react-router-dom'
import { ResourceListingInfoIcon } from './ResourceListingInfoIcon'
import { Tooltip } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'

const AttributeValue = styled(Box)(({ theme }) => ({
    fontSize: '15px',
    fontWeight: 'bold',
    lineHeight: 1.33,
    color: theme?.palette?.primary?.main,
    display: 'block',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
}))

const HighlightedClickableLabel = ({ attribute, data }) => {
    const history = useHistory()
    return (
        <Box
            className="font-size-large"
            style={{
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
            }}
            paddingY="10px"
            onClick={() => {
                history.push(
                    `?${attribute.component.queryParam}=${
                        data?.item?.[attribute.component.idParam]
                    }`,
                )
            }}
        >
            <AttributeValue margin={'0px'}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {' '}
                    {isNilOrEmpty(data.item[attribute.name])
                        ? '-'
                        : data.item[attribute.name]}
                    {attribute.moreInfoIcon && (
                        <ResourceListingInfoIcon
                            attribute={attribute}
                            data={data}
                        ></ResourceListingInfoIcon>
                    )}
                    {data?.item?.lastFailedError && (
                        <Tooltip
                            title={data.item.lastFailedError}
                       
                            tooltipStyles={{
                                boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
                                padding: '8px',
                                maxWidth: '400px',
                            }}
                        >
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    cursor: 'default',
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Icon name="Attention" style={{ width: '16px', height: '16px', color: '#d0021b' }} />
                            </span>
                        </Tooltip>
                    )}
                </div>
            </AttributeValue>
        </Box>
    )
}

export default HighlightedClickableLabel
